<template>
  <div class="c-page">
    <div class="c-page-hd">
      <div class="breadcrumb">
        <div class="breadcrumb-item" v-for="(route, index) in activeRoutes" :key="index">
          <template v-if="index === activeRoutes.length - 1">
            <a class="current-route" @click="toRoute(route)">
              {{ route.meta.title }}
            </a>
          </template>
          <template v-else>
            <a @click="toRoute(route)">{{ route.meta.title }}</a>
            <span class="mx-1">&gt;</span>
          </template>
        </div>
      </div>
      <slot name="header"></slot>
      <div class="header-extra">
        <div class="time">
          {{ time }}
          <span class="ml-1">{{ weekday }}</span>
        </div>
        <div class="action" @click="toggleFullscreen">
          <app-icon type="icon-quanping" class="action-icon"></app-icon>
        </div>
        <div class="action">
          <a-popover placement="bottom" trigger="click">
            <template slot="content">
              <div class="flex flex-col gap-2" style="width:90px">
                <div
                  v-for="item in menuTabs"
                  :key="item.key"
                  class="flex gap-1 items-center cursor-pointer hover:text-red-300"
                  @click="selectNotice(item)"
                >
                  <span class="notice-title">{{ item.title }}</span>
                  <span v-if="item.info" class="notice-info">
                    {{ item.info }}
                  </span>
                </div>
              </div>
            </template>
            <span>
              <a-badge :count="noticeCount" :number-style="{ backgroundColor: '#FF4D4F' }">
                <app-icon type="icon-xiaoxi" class="action-icon"></app-icon>
              </a-badge>
            </span>
          </a-popover>
        </div>
        <div class="action">
          <menu-user-avatar />
        </div>
      </div>
    </div>
    <div class="c-page-bd">
      <div class="content-top" v-if="$slots.contentTop">
        <slot name="contentTop"></slot>
      </div>
      <div class="content-center" v-if="$slots.contentCenter">
        <slot name="contentCenter"></slot>
      </div>
      <div class="content-main">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import treeUtils from '@/utils/treeUtils'
import { toggleFullscreen } from '@/utils/fullscreen'
import { toChinseDigit } from '@/utils/format'
import MenuUserAvatar from '@/components/MenuUserAvatar'
import moment from 'moment'
let timer = null
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    breadCrumb: {
      type: Function,
      /**
       * 返回值是 一个  []<route|string> 路由对象 或者 string(title)
       */
      default: routes => {
        return routes
      },
    },
  },
  components: {
    MenuUserAvatar,
  },
  data() {
    return {
      time: this.getTime(),
      weekday: `星期${toChinseDigit(moment().isoWeekday())}`,
    }
  },
  computed: {
    ...mapState({
      menus: state => state.permission.menus,
      routes: state => state.permission.asyncRouterMap.find(rootRoute => rootRoute.path === '/m'),

      menuTabs: state => state.menuPanel.menuTabs,
    }),

    activeRoutes() {
      // 一级目录不处理
      const activeRoutes = treeUtils.findAllParents(this.menus, m => {
        return m.path === this.$route.path
      })
      activeRoutes.shift()
      const result = [...activeRoutes, this.$route]
      // 标准上的展示为前2级对应菜单。后面的，通过breaCrumb 函数自定义
      return this.normalBreadCrumb(this.breadCrumb(result.slice(0, 2)))
    },
    noticeCount() {
      let num = 0
      for (const tab of this.menuTabs) {
        num += Number(tab.info) || 0
      }
      return num
    },
  },
  methods: {
    normalBreadCrumb(breadCrumb) {
      const result = []
      breadCrumb.map(b => {
        if (typeof b === 'string') {
          result.push({
            meta: { title: b },
            path: '',
          })
        } else {
          result.push({
            meta: b.meta,
            path: b.path,
          })
        }
      })
      return result
    },
    toRoute(route) {
      this.$router.push(route.path)
    },
    toggleFullscreen() {
      toggleFullscreen()
    },
    getTime() {
      const current = moment()

      return current.format('YYYY年MM月DD日 HH:mm:ss')
    },
    startTimer() {
      clearInterval(timer)
      timer = setInterval(() => {
        this.time = this.getTime()
      }, 1000)
    },
    selectNotice(item) {
      this.$router.push({
        path: '/m/scopeMain/menuPanel',
        query: {
          activeKey: item.key,
        },
      })
    },
  },

  created() {
    this.startTimer()
  },
}
</script>

<style lang="less" scoped>
.c-page-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  .breadcrumb {
    flex: 0 0 auto;
    padding-left: 16px;
    display: flex;
    position: relative;

    &:before {
      content: '';
      width: 4px;
      height: 26px;
      position: absolute;
      top: -2px;
      left: 0;
      background: @primary-color;
    }
    .breadcrumb-item {
      a {
        color: #999;
      }
      span {
        color: #999;
      }
      a.current-route {
        color: #333;
      }
    }
  }
  .header-extra {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    .time {
      color: #999;
    }

    .action {
      cursor: pointer;
      margin-left: 20px;
      transition: all 0.3s;
      font-size: 16px;
      position: relative;
      &:last-child {
        &:after {
          display: none;
        }
      }
      .action-icon {
        font-size: 24px;
      }
      .action-text {
        margin-left: 16px;
      }
    }
  }
}
::v-deep .notice-info {
  min-width: 16px;
  height: 16px;
  padding: 0 2px;
  border-radius: 999px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: @primary-color;
}
</style>
